import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductGallery } from '../components/ProductGallery';
import { ProductInfo } from '../components/ProductInfo';
import { ProductSpecs } from '../components/ProductSpecs';
import { CustomerLogin } from '../components/CustomerLogin';
export function ProductPage() {
  return <div className="min-h-screen bg-white font-sans text-brand-charcoal" data-id="element-242">
      <Header data-id="element-243" />

      <main className="max-w-7xl mx-auto px-4 py-8 md:py-12" data-id="element-244">
        {/* Breadcrumbs */}
        <div className="text-sm text-gray-500 mb-6 flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-245">
          <a href="#" className="hover:text-brand-red" data-id="element-246">
            Home
          </a>
          <span data-id="element-247">/</span>
          <a href="#" className="hover:text-brand-red" data-id="element-248">
            Products
          </a>
          <span data-id="element-249">/</span>
          <span className="text-gray-900 font-medium" data-id="element-250">
            1/8" VI-Pro Corner Radius End Mill Carbide 4 Flute Vari Index Stub
            Length AlCrN Coated TITAN CR=.005"
          </span>
        </div>

        {/* Top Section: Gallery & Info */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-251">
          <ProductGallery data-id="element-252" />
          <ProductInfo data-id="element-253" />
        </div>

        {/* Middle Section: Specs */}
        <ProductSpecs data-id="element-254" />

        {/* Bottom Section: Login */}
        <CustomerLogin data-id="element-255" />
      </main>

      <Footer data-id="element-256" />
    </div>;
}